import { Clear, ShoppingBag, Star } from "@mui/icons-material";
import {
  Avatar,
  Fade,
  IconButton,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { FC, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import AnimateButton from "../../../components/@extended/AnimateButton";
import { formatNumberWithThousandsSeparator } from "../../../helpers";
import { openCart } from "../../../stateManagement/reducers/cartReducer";
import {
  IRentalItem,
  setMainRentalItem,
} from "../../../stateManagement/reducers/rentalItemsReducer";
import SelectionButton from "./SelectionButton";

interface IServiceDetailsProps {
  rentalItem: IRentalItem;
}

const ServiceDetails: FC<IServiceDetailsProps> = ({ rentalItem }) => {
  //in ms
  const transTime = 500;

  const theme = useTheme();
  const idGreaterThanMd = useMediaQuery(theme.breakpoints.up("md"));
  const [show, setShow] = useState(false);
  const dispatch = useDispatch<any>();

  const goBack = () => {
    setShow(false);
    setTimeout(() => {
      dispatch(setMainRentalItem(null));
    }, transTime);
  };

  useEffect(() => {
    window.scrollTo(0, 0);

    if (!show) {
      setShow(true);
    }
  }, []);

  return (
    <Fade in={show} timeout={transTime}>
      <div className="fixed top-0 left-0 w-full h-full bg-paper flex px-[1rem] md:px-[2rem] overflow-y-auto z-20">
        <Stack sx={{ width: "100%", mx: "auto" }}>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            sx={{ pt: { xs: "4.5rem", md: "8.5rem" } }}
          >
            <AnimateButton>
              <IconButton onClick={goBack} sx={{ color: "red" }}>
                <Clear />
              </IconButton>
            </AnimateButton>
            <h2 className=" md:text-[40px] leading-tight text-[1.25rem] font-bold text-primary">
              {rentalItem.name}
            </h2>
            <IconButton sx={{ color: "red", opacity: 0 }}>
              <Clear />
            </IconButton>
          </Stack>
          <Stack
            direction={idGreaterThanMd ? "row" : "column"}
            alignItems={idGreaterThanMd ? "flex-start" : "center"}
            justifyContent="center"
            spacing={idGreaterThanMd ? "4rem" : "2rem"}
            sx={{ width: "100%", mt: "4rem" }}
          >
            <Avatar
              variant="rounded"
              sx={{
                height: { xs: "30vh", md: "50vh" },
                width: { xs: "50vw", md: "18.75rem" },
                backgroundColor: theme.palette.primary.main,
                backdropFilter: "blur(4px) saturate(140%)",

                "& img": {
                  width: "100% !important",
                  height: "100% !important",
                  objectFit: "cover !important",
                },
              }}
              alt="profile user"
              src={`${process.env.REACT_APP_SERVER_ENDPOINT}/${rentalItem.imgSrc}`}
            >
              <ShoppingBag sx={{ width: "10rem", height: "10rem" }} />
            </Avatar>
            <Stack sx={{ maxWidth: "500px", width: "100%" }}>
              <p className="md:text-[.9rem] text-[.8rem] text-grey font-normal max-w-45 w-full mx-auto my-[1rem] sm:px-0 px-4 tracking-[0.02rem]">
                {rentalItem.description}
              </p>
              <p className="md:text-[.9rem] text-[.8rem] text-grey font-normal max-w-45 w-full mx-auto my-[1rem] sm:px-0 px-4 tracking-[0.02rem]">
                Rating:{" "}
                <span>
                  <Star
                    sx={{
                      color: "gold",
                      height: "1.25rem",
                      width: "1.25rem",
                      textShadow: "2px 2px 6px rgba(0, 0, 0, 1) !important",
                    }}
                  />
                  <Star
                    sx={{
                      color: "gold",
                      height: "1.25rem",
                      width: "1.25rem",
                      textShadow: "2px 2px 6px rgba(0, 0, 0, 1) !important",
                    }}
                  />
                  <Star
                    sx={{
                      color: "gold",
                      height: "1.25rem",
                      width: "1.25rem",
                      textShadow: "2px 2px 6px rgba(0, 0, 0, 1) !important",
                    }}
                  />
                  <Star
                    sx={{
                      color: "gold",
                      height: "1.25rem",
                      width: "1.25rem",
                      textShadow: "2px 2px 6px rgba(0, 0, 0, 1) !important",
                    }}
                  />
                  <Star
                    sx={{
                      color: "gold",
                      height: "1.25rem",
                      width: "1.25rem",
                      textShadow: "2px 2px 6px rgba(0, 0, 0, 1) !important",
                    }}
                  />
                </span>
              </p>
              <Typography
                sx={{
                  width: "fit-content",
                  textShadow: "2px 2px 6px rgba(0, 0, 0, .6)",
                }}
                className="md:text-[.9rem] text-[.8rem] text-grey font-normal max-w-45 w-full mx-auto my-[1rem] sm:px-0 px-4 tracking-[0.02rem]"
              >
                ₦{formatNumberWithThousandsSeparator(rentalItem.pricePerDay)}
              </Typography>
              <Stack
                alignItems={idGreaterThanMd ? "flex-start" : "center"}
                sx={{ width: "100%" }}
              >
                <SelectionButton
                  rentalItem={rentalItem}
                  openCartModal={() => {
                    dispatch(openCart());
                  }}
                />
              </Stack>
            </Stack>
          </Stack>
        </Stack>
      </div>
    </Fade>
  );
};

export default ServiceDetails;
